<template>
    <div class="filter-bar">
      <form class="form is-inline">
        <div class="field is-grouped">
          <label class="has-margin-right-1">Suchen:</label>
          <div class="control is-expanded">
            <input type="text" class="input is-small" v-model="filterText" @keyup.enter="doFilter" placeholder="Suchen">
          </div>
          <div class="control">
          <button class="button is-small is-primary has-text-weight-bold is-uppercase " @click.prevent="doFilter">Los</button>
          <button class="button is-small has-text-weight-bold is-uppercase" @click.prevent="resetFilter">Zurücksetzen</button>
          </div>
        </div>
      </form>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        filterText: ''
      }
    },
    methods: {
      doFilter () {
        this.$events.fire('filter-set', this.filterText)
      },
      resetFilter () {
        this.filterText = ''
        this.$events.fire('filter-reset')
      }
    }
  }
</script>
<style>
.filter-bar {
  padding: 10px;
  max-width: 600px;
}

@media screen and (max-width: 1023px) {
  .filter-bar .field.is-grouped {
    flex-wrap: wrap;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/FilterBar.vue